import React, { useState, useEffect } from "react"

const WhySection = () => {
  return (
    <>
      <div
        className="margin-100-zero"
        style={{ textAlign: "center", marginTop: 100 }}
      >
        <div className="header-title-2" style={{ marginBottom: 20 }}>
          {"Kodėl verta rinktis Siųsk24"}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <p className="text-font" style={{ maxWidth: 880 }}>
            {
              "Siuntų užsakymas bei valdymas neturi būti kasdienis rūpestis. Todėl sukūrėme inovatyvią ir patogią platformą, kurios pagalba ne tik greitai gausite geriausią siuntimo pasiūlymą, bet ir paprastai išsiųsite savo verslo siuntas į bet kurią pasaulio šalį. Pradėkite naudotis Siųsk24 teikiamais privalumais jau šiandien."
            }
          </p>
        </div>
      </div>
    </>
  )
}

export default WhySection
